// import React, { useEffect, useState } from "react";
// import label1000ml from "./correct10000ml.png";
// import label500ml from "./a17-500ml.png";
// import label250ml from "./a17-250ml.png";

// const Bottle = () => {
//     const [active, setActive] = useState(0); // 0-indexed for cleaner item mapping
//     const [isMobile, setIsMobile] = useState(false);

//     // Dynamic scale setup for mobile vs desktop views
//     useEffect(() => {
//         const handleResize = () => setIsMobile(window.innerWidth < 768);
//         handleResize();
//         window.addEventListener("resize", handleResize);
//         return () => window.removeEventListener("resize", handleResize);
//     }, []);

//     // Automatic rotating presentation loop
//     useEffect(() => {
//         const interval = setInterval(() => {
//             setActive((prev) => (prev === 2 ? 0 : prev + 1));
//         }, 3500);
//         return () => clearInterval(interval);
//     }, []);

//     const bottles = [
//         { img: label250ml, size: "250ml", desc: "Compact Hydro Pocket Cell" },
//         { img: label500ml, size: "500ml", desc: "Daily Performance Core Unit" },
//         { img: label1000ml, size: "1000ml", desc: "Extended Volume Max Cell" }
//     ];

//     const styles = {
//         wrapper: {
//             minHeight: "100vh",
//             width: "100%",
//             background: "#2c3437",
//             backgroundImage: "url('https://transparenttextures.com')",
//             backgroundRepeat: "repeat",
//             backgroundBlendMode: "multiply",
//             display: "flex",
//             flexDirection: "column",
//             justifyContent: "center",
//             alignItems: "center",
//             fontFamily: "'Montserrat', sans-serif",
//             color: "white",
//             padding: isMobile ? "80px 20px" : "120px 40px",
//             boxSizing: "border-box",
//             position: "relative",
//             overflow: "hidden",
//         },
//         glowBackdrop: {
//             position: "absolute",
//             width: isMobile ? "250px" : "450px",
//             height: isMobile ? "250px" : "450px",
//             borderRadius: "50%",
//             background: "radial-gradient(circle, rgba(110,193,228,0.12) 0%, rgba(0,0,0,0) 70%)",
//             filter: "blur(30px)",
//             zIndex: 1,
//             pointerEvents: "none",
//         },
//         displayZone: {
//             position: "relative",
//             zIndex: 2,
//             display: "flex",
//             flexDirection: "column",
//             alignItems: "center",
//             justifyContent: "center",
//             width: "100%",
//             maxWidth: "500px",
//             height: isMobile ? "320px" : "460px",
//             marginBottom: "30px",
//         },
//         imageRender: (index) => ({
//             position: "absolute",
//             maxHeight: isMobile ? "280px" : "420px",
//             maxWidth: "85%",
//             objectFit: "contain",
//             opacity: active === index ? 1 : 0,
//             transform: active === index ? "scale(1) translateY(0)" : "scale(0.85) translateY(30px)",
//             filter: active === index
//                 ? "drop-shadow(0px 15px 25px rgba(0,0,0,0.4))"
//                 : "drop-shadow(0px 0px 0px rgba(0,0,0,0))",
//             transition: "all 0.8s cubic-bezier(0.4, 0, 0.2, 1)",
//             pointerEvents: active === index ? "auto" : "none",
//         }),
//         infoBox: {
//             zIndex: 2,
//             textAlign: "center",
//             minHeight: "65px",
//             marginBottom: "35px",
//         },
//         sizeHeader: {
//             fontSize: isMobile ? "24px" : "32px",
//             fontWeight: "900",
//             color: "#ffffff",
//             letterSpacing: "2px",
//             marginBottom: "4px",
//         },
//         descText: {
//             fontSize: isMobile ? "12px" : "14px",
//             color: "#6ec1e4",
//             letterSpacing: "1px",
//             fontWeight: "500",
//             textTransform: "uppercase",
//         },
//         controlsContainer: {
//             zIndex: 2,
//             display: "flex",
//             gap: "15px",
//             justifyContent: "center",
//             alignItems: "center",
//         },
//         badgeButton: (isActive) => ({
//             background: isActive ? "#6ec1e4" : "rgba(255,255,255,0.04)",
//             border: isActive ? "1px solid #6ec1e4" : "1px solid rgba(255,255,255,0.15)",
//             color: isActive ? "#2c3437" : "#cfd8dc",
//             padding: isMobile ? "10px 20px" : "12px 28px",
//             borderRadius: "9999px",
//             fontSize: isMobile ? "12px" : "14px",
//             fontWeight: "700",
//             letterSpacing: "1px",
//             cursor: "pointer",
//             transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
//             boxShadow: isActive ? "0px 8px 20px rgba(110,193,228,0.3)" : "none",
//         })
//     };

//     return (
//         <div id="design" style={styles.wrapper}>
//             {/* Ambient High-Tech Light Circle */}
//             <div style={styles.glowBackdrop} />

//             {/* Core Bottle Graphic Switching Frame */}
//             <div style={styles.displayZone}>
//                 {bottles.map((bottle, idx) => (
//                     <img
//                         key={bottle.size}
//                         src={bottle.img}
//                         alt={`A17 Water bottle asset - ${bottle.size}`}
//                         style={styles.imageRender(idx)}
//                     />
//                 ))}
//             </div>

//             {/* Dynamic Content Specifications */}
//             <div style={styles.infoBox}>
//                 <div style={styles.sizeHeader}>{bottles[active].size}</div>
//                 <div style={styles.descText}>{bottles[active].desc}</div>
//             </div>

//             {/* Interactive Selector Pill Control Belt */}
//             <div style={styles.controlsContainer}>
//                 {bottles.map((b, idx) => (
//                     <button
//                         key={b.size}
//                         onClick={() => setActive(idx)}
//                         style={styles.badgeButton(active === idx)}
//                     >
//                         {b.size}
//                     </button>
//                 ))}
//             </div>
//         </div>
//     );
// };

// export default Bottle;



import React, { useEffect, useState, useCallback, useRef } from "react";
import label1000ml from "./correct10000ml.png";
import label500ml from "./a17-500ml.png";
import label250ml from "./a17-250ml.png";

const BOTTLES = [
  { img: label250ml, size: "250ml", desc: "Compact Hydro Pocket Cell" },
  { img: label500ml, size: "500ml", desc: "Daily Performance Core Unit" },
  { img: label1000ml, size: "1000ml", desc: "Extended Volume Max Cell" }
];

const Bottle = ({ isMobile, scrollProgress }) => {
  const [active, setActive] = useState(0);
  const timerRef = useRef(null);

  // Helper to start/reset rotation timer
  const startTimer = useCallback(() => {
    if (timerRef.current) clearInterval(timerRef.current);
    timerRef.current = setInterval(() => {
      setActive((prev) => (prev === BOTTLES.length - 1 ? 0 : prev + 1));
    }, 3500);
  }, []);

  // Automatic presentation loop
  useEffect(() => {
    startTimer();
    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, [startTimer]);

  // Handle manual selection and reset auto-play timer
  const handleSelect = (index) => {
    setActive(index);
    startTimer();
  };

  return (
    <div
      id="design"
      style={{
        minHeight: "100vh",
        width: "100%",
        backgroundColor: "#2c3437",
        backgroundImage: "url('https://transparenttextures.com')",
        backgroundRepeat: "repeat",
        backgroundBlendMode: "multiply",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        fontFamily: "'Montserrat', sans-serif",
        color: "white",
        padding: isMobile ? "80px 20px" : "120px 40px",
        boxSizing: "border-box",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Ambient Backdrop Glow */}
      <div
        style={{
          position: "absolute",
          width: isMobile ? "250px" : "450px",
          height: isMobile ? "250px" : "450px",
          borderRadius: "50%",
          background: "radial-gradient(circle, rgba(110,193,228,0.12) 0%, rgba(0,0,0,0) 70%)",
          filter: "blur(30px)",
          zIndex: 1,
          pointerEvents: "none",
        }}
      />

      {/* Core Bottle Graphic Frame */}
      <div
        style={{
          position: "relative",
          zIndex: 2,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          maxWidth: "500px",
          height: isMobile ? "320px" : "460px",
          marginBottom: "30px",
        }}
      >
        {BOTTLES.map((bottle, idx) => {
          const isActive = active === idx;
          return (
            <img
              key={bottle.size}
              src={bottle.img}
              alt={`A17 Water bottle asset - ${bottle.size}`}
              style={{
                position: "absolute",
                maxHeight: isMobile ? "280px" : "420px",
                maxWidth: "85%",
                objectFit: "contain",
                opacity: isActive ? 1 : 0,
                transform: isActive ? "scale(1) translateY(0)" : "scale(0.85) translateY(30px)",
                filter: isActive
                  ? "drop-shadow(0px 15px 25px rgba(0,0,0,0.4))"
                  : "drop-shadow(0px 0px 0px rgba(0,0,0,0))",
                transition: "all 0.8s cubic-bezier(0.4, 0, 0.2, 1)",
                pointerEvents: isActive ? "auto" : "none",
              }}
            />
          );
        })}
      </div>

      {/* Dynamic Content Specifications */}
      <div
        style={{
          zIndex: 2,
          textAlign: "center",
          minHeight: "65px",
          marginBottom: "35px",
        }}
      >
        <div
          style={{
            fontSize: isMobile ? "24px" : "32px",
            fontWeight: "900",
            color: "#ffffff",
            letterSpacing: "2px",
            marginBottom: "4px",
          }}
        >
          {BOTTLES[active].size}
        </div>
        <div
          style={{
            fontSize: isMobile ? "12px" : "14px",
            color: "#6ec1e4",
            letterSpacing: "1px",
            fontWeight: "500",
            textTransform: "uppercase",
          }}
        >
          {BOTTLES[active].desc}
        </div>
      </div>

      {/* Interactive Selector Pill Control Belt */}
      <div
        style={{
          zIndex: 2,
          display: "flex",
          gap: "15px",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {BOTTLES.map((b, idx) => {
          const isActive = active === idx;
          return (
            <button
              key={b.size}
              type="button"
              onClick={() => handleSelect(idx)}
              style={{
                background: isActive ? "#6ec1e4" : "rgba(255,255,255,0.04)",
                border: isActive ? "1px solid #6ec1e4" : "1px solid rgba(255,255,255,0.15)",
                color: isActive ? "#2c3437" : "#cfd8dc",
                padding: isMobile ? "10px 20px" : "12px 28px",
                borderRadius: "9999px",
                fontSize: isMobile ? "12px" : "14px",
                fontWeight: "700",
                letterSpacing: "1px",
                cursor: "pointer",
                transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                boxShadow: isActive ? "0px 8px 20px rgba(110,193,228,0.3)" : "none",
                outline: "none",
              }}
            >
              {b.size}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default Bottle;